import request from '@/utils/request'


export function do_transfer(form) {
    return request({
        url: '/api/transfer/do_transfer',
        method: 'post',
        data: {
          money: form.money,
          to_user: form.toUser,
          pay_password: form.payPassword
        }
    })
}
export function vip_transfer(form) {
    return request({
        url: '/api/transfer/vip_transfer',
        method: 'post',
        data: form
    })
}
export function get_vip_transfer(form) {
    return request({
        url: '/api/transfer/get_vip_transfer',
        method: 'post',
        data: form
    })
}
